import DOMPurify from 'isomorphic-dompurify';

import Container from '@/components/@base/container';
import Section from '@/components/app/product/components/@shared/section';
import StepTimelineAccordion from '@/components/app/product/components/content/description-ready-site';
import Props from '@/components/app/product/components/content/details/type';

export default function Details({ content, isReadySite, ...props }: Props) {
  const descriptionContent = DOMPurify.sanitize(content);
  return (
    <Section
      id='productDescriptionSection'
      expandable
      forcedMaxHeight={isReadySite ? 690 : undefined}
      className='mx-0 p-0! md:max-h-[1200px]'
    >
      {isReadySite && <StepTimelineAccordion />}

      <Container className='px-[15px] py-[25px] text-[#424244] md:p-[38px]'>
        <article
          className='custom-inner-html'
          dangerouslySetInnerHTML={{ __html: descriptionContent }}
        />
      </Container>
    </Section>
  );
}
